import image from "../../assetsCon/assets/img/illustrations/auth-basic-login-mask-light.png";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { triggerNotification } from "../message/Msg";
import config from "../../config";

function Login() {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      window.location.href = "/home";
    }
  }, []);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the username and password fields are empty
    if (!formData.username.trim() || !formData.password.trim()) {
      // Show an error message if any of the fields is blank
      triggerNotification("error", "Input field cannot be empty!!");
      return; // Stop form submission
    }

    // Call the API with formData
    try {
      await fetch(`${config.host_url}admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          console.log(data);
          if (data.status === 200) {
            // console.log(data);
            localStorage.setItem("token", data.token);
            localStorage.setItem("usertype", data.usertype);
            localStorage.setItem("name", data.name);
            window.location.href = "/home";
          } else {
            triggerNotification("error", "Please Enter a Valid Credential!!");
          }
        });
    } catch (error) {
      console.log(error);
      triggerNotification(
        "error",
        "Some Error Occur!! Please Login After Some Time"
      );
    }
  };

  return (
    <div>
      <div className="position-relative">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-4">
            <div className="card p-2">
              <div className="app-brand justify-content-center mt-3">
                <a href="/" className="app-brand-link gap-2">
                  <img
                    className="app-brand-text demo text-heading fw-bold w-48 "
                    src="https://deepvecto.com/wp-content/uploads/2023/09/Deepvecto_Logo.png"
                  />
                </a>
              </div>
              <div className="card-body mt-2 pb-0">
                <h4 className="mb-2">Welcome to Deepvecto! 👋</h4>
                <p className="mb-4">
                  Please login to your account and start the adventure
                </p>
                <form className="mb-3" method="POST" onSubmit={handleSubmit}>
                  <div className="form-floating form-floating-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="Enter your username"
                      autoFocus
                    />
                    <label htmlFor="username">Username</label>
                  </div>
                  <div className="mb-3">
                    <div className="form-password-toggle">
                      <div className="input-group input-group-merge">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="password"
                            id="password"
                            className="form-control"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                            aria-describedby="password"
                          />
                          <label htmlFor="password">Password</label>
                        </div>
                        <span className="input-group-text cursor-pointer">
                          <i className={config.eye_off_outline}></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <button
                      className="btn btn-primary d-grid w-100"
                      type="submit"
                    >
                      Login
                    </button>
                  </div>
                </form>
                <span>
                  <Link to="/forgotpassadmn">
                    <span>Forgot Password?</span>
                  </Link>
                </span>
              </div>
              <hr />
              <p className="text-center">
                <span>New on our platform? </span>
                <Link to="/signup">
                  <span
                  // onClick={() => {
                  //   window.location.href = "/signup";
                  // }}
                  // className="text-[#666CFF]"
                  >
                    Create an account
                  </span>
                </Link>
              </p>
            </div>
            <img
              alt="mask"
              src={image}
              className="authentication-image d-none d-lg-block"
              data-app-dark-img="illustrations/auth-basic-login-mask-dark.html"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
